import { Button, Card, Col, Form, Input, Row, Switch, Popconfirm } from "antd"
import { useEffect, useState } from "react";
import AddressSection from "./Components/AddressSection";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from 'dayjs'
import { useGlobal } from "../../System/Global/GlobalProvider";
import { parseStringifiedArrays, unescapeNested } from "../../System/Global/unescapeArray";
import { getRecords, deleteRecords } from "../../System/Api/OPEXAPI";
export const BookingDraftView = () => {

    const [ form ] = Form.useForm()
    const { UserData } = useGlobal()
    const [ client, setClient ] = useState()
    const [ collections, setCollections ] = useState([])
    const [ deliveries, setDeliveries ] = useState([])
    const { bookingKey } = useParams();
    const [isRoundTrip, setIsRoundTrip] = useState(false); 
    const [ booking, setBooking ] = useState();
    const [ isLoading, setIsLoading ] = useState(false)
    const [ typeCode, setTypeCode ] = useState() // used for avonmouth site type 3
    const navigate = useNavigate()


    const generateAddress = (b, prefix) => {

        let newAddresses = [{
            name:           b[`${prefix}_name`],
            addressLine1:   b[`${prefix}_addressLine1`],
            addressLine2:   b[`${prefix}_addressLine2`],
            addressLine3:   b[`${prefix}_addressLine3`],
            townName:       b[`${prefix}_townName`],
            postCode:       b[`${prefix}_postCode`],
            country:        b[`${prefix}_country`],
            date:           dayjs(b[`${prefix}_date`]).format('YYYY-MM-DD'),
            time:           b[`${prefix}_time`],
            timeType:       b[`${prefix}_time`] !== "ASAP" ? "Timed" : "ASAP",
            instructions:   b[`${prefix}_instructions`],
            reference:      b[`${prefix}_reference`],
        }]

        let items = prefix === "col" ? b.collections : b.deliveries;


        if (Array.isArray(items)) {
            items.forEach(item => newAddresses.push({
                name:           item[`${prefix}_name`],
                addressLine1:   item[`${prefix}_addressLine1`],
                addressLine2:   item[`${prefix}_addressLine2`],
                addressLine3:   item[`${prefix}_addressLine3`],
                townName:       item[`${prefix}_townName`],
                postCode:       item[`${prefix}_postCode`],
                country:        item[`${prefix}_country`],
                date:           dayjs(item[`${prefix}_date`]).format('YYYY-MM-DD'),
                time:           b[`${prefix}_time`],
                timeType:       b[`${prefix}_time`] !== "ASAP" ? "Timed" : "ASAP",
                instructions:   item[`${prefix}_instructions`],
                reference:      item[`${prefix}_reference`],
            }))
        } else {
            console.error('items is not an array:', items)
        }

        
        if (prefix === "col") {
            setCollections(newAddresses)
        } else {
            setDeliveries(newAddresses)
        }

    }

    useEffect( () => {

        ( async () => {

            let _booking = await getRecords(`SELECT * FROM bookings_draft WHERE bookingKey = ?`, [ bookingKey ])
            _booking = unescapeNested(_booking[0])
            _booking = parseStringifiedArrays(_booking)
            
            setBooking(_booking)

            generateAddress(_booking, 'col')
            generateAddress(_booking, 'del')

                
            form.setFieldsValue({
                itemCount:      _booking.itemCount,
                itemKgs:        _booking.itemKgs,
                itemText:       _booking.itemText,
                itemType:       _booking.itemType,
                typeCode:       _booking.typeCode,
                vanType:        _booking.vanType,
                basePrice:      _booking.basePrice,
                vatCode:        _booking.vatCode,
                ignorePod:      _booking.ignorePod,
                customsBooking: _booking.customsBooking,
                orderNo:        _booking.orderNo,
                customerRef:    _booking.customerRef,
            })

            setTypeCode(_booking.typeCode)

            if (_booking.roundTrip === 1) {
                setIsRoundTrip(true)
            }
            

            const _client = await getRecords(`SELECT * FROM clients WHERE clientKey = ?`, [ UserData.clientKey ])
            setClient(_client[0])
            setBooking(_booking)

            setIsLoading(false)

            
        })()
        

    },[])

    
    const priceCard = () => {

        return (
            <Card>
                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>

                
                
                <Row gutter={16} display="flex" align={"middle"}>
                    <Col xs={10}>
                        <Form.Item label="Price" name="basePrice" rules={[
                            {
                                required: true,
                                message: 'Please enter a price!',
                            }]}>
                            <Input type="number"/>
                        </Form.Item>
                    </Col>
                    
                    
                    <Col xs={14}>
                        { typeCode !== "3" &&
                        <Form.Item label={"Vehicle Type"} name="vanType">
                                <Input disabled />
                        </Form.Item> }
                    </Col>
                    
                </Row> 
                </div>
            </Card>
        )
    }
    const detailsCard = () => {

        return (
            
            <Card>

                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>
                
                <Row gutter={16} display="flex" align={"middle"}>
                    
                    <Col xs={12}>
                        <Form.Item label="Order No" name="orderNo" rules={[
                            {
                                required: true,
                                message: 'Please enter an order number!',
                            }]}>
                            <Input/>
                        </Form.Item>
                        
                    </Col>
                    <Col xs={12}>
                        <Form.Item label="Your Ref (optional)" name="customerRef">
                            <Input/>
                        </Form.Item>
                    </Col>
                </Row>

                </div>
                
            </Card> 
        )
    }

    const deleteBooking = async () => {

        await deleteRecords(`DELETE FROM bookings_draft WHERE bookingKey = ?`, [ bookingKey ])
        
        navigate('/bookings/Draft')

    }

    return (
        isLoading && booking ?  <Row gutter={16}>
        <Col xs={24}></Col></Row> :
        <div style={{padding: 20}}>
        <Row gutter={16}>
            <Col xs={24}>
            <Form form={form} layout="vertical" initialValues={booking}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h1 style={{marginTop: 0}}>{ "View Booking" }</h1>
                </div>
                <div>
                    <Switch disabled checked={isRoundTrip} style={{marginRight: 20}} checkedChildren="Round Trip" unCheckedChildren="One-way" onChange={(checked) => setIsRoundTrip(checked)} />
                </div>
            </div>

            { booking && 

            <div>
                <>
                
                <Row gutter={10}>
                    
                    <Col span={12}>
                        <AddressSection disabled addresses={collections} setAddresses={setCollections} client={client} type="Collection"/>
                    </Col>
                    <Col span={12}>
                        <AddressSection disabled addresses={deliveries} setAddresses={setDeliveries} client={client} type="Delivery"/>
                    </Col>
                    <Col span={24}>
                        <ItemsSection/>
                    </Col>
                </Row>
                
                <Row gutter={10}>
                    <Col xs={12}>
                        { priceCard() }
                    </Col>
                    <Col xs={12}>
                        { detailsCard() }
                    </Col>
                </Row>

                <Popconfirm title="Are you sure you want to delete this booking?" onConfirm={deleteBooking}>
                    <Button style={{width: '100%'}} type="primary">Delete Booking</Button> 
                </Popconfirm>

                </>
            </div> 
            }
            </Form>
            </Col>
        </Row>
        </div>
    )
}


const inputStyle = {
    // height: 30,
    // fontSize: 12
}
const formItemStyle = {
    marginBottom: 5,
    // minHeight: 30,
    
}

const ItemsSection = () => {

    return (
        <Card style={{margin: 10}}>
            <div style={{padding: 20, border: '1px solid #F1F2F5'}}>
            
                <Row gutter={16}>
                    <Col span={4}>
                        <Form.Item name="itemCount" label="Qty" style={formItemStyle} className="small" rules={[
                            {
                                required: true,
                                message: 'Please enter the qty!',
                            }]}>
                            <Input type="number" style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemType" label="Type"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the items type!',
                            }]}>
                        <Input style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemKgs" label="Kgs"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the weight!',
                            }]}>
                        <Input type="number" style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="itemText" label="Description"  style={formItemStyle}>
                        <Input style={inputStyle} />
                        </Form.Item>
                    </Col>
                </Row>
            
            </div>
        </Card>
    )
}
